import {Injectable, signal} from '@angular/core';
import {designBlockFilesPath} from "../configs/design-block-files-config";

@Injectable({
  providedIn: 'root'
})
export class DbFilePathStateService {
  private _pathFileState = signal<string>('');
  public pathFileState = this._pathFileState.asReadonly();

  public setPathFileState(modalKey: string): void {
    this._pathFileState.set(designBlockFilesPath[modalKey]);
  }

  public resetPathFileState(): void {
    this._pathFileState.set('');
  }
}
